import React from 'react';
import Sheet from 'react-modal-sheet';
import useDialogA11y from '../hooks/useDialogA11y';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
	const dialogRef = useDialogA11y(isOpen, onClose);

	return (
		<Sheet isOpen={isOpen} onClose={onClose}>
			<Sheet.Container>
				<div
					ref={dialogRef}
					role="dialog"
					aria-modal="true"
					aria-labelledby="privacy-modal-title"
				>
					<div className="d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
						<h2 id="privacy-modal-title" className="fs-16 fw-700 m-0">
							Privacy Policy
						</h2>
						<button
							type="button"
							className="closeModal"
							onClick={onClose}
							aria-label="Close Privacy Policy"
							style={{
								background: 'none',
								border: 'none',
								fontSize: '24px',
								fontWeight: 'bold',
								cursor: 'pointer',
								padding: '4px 10px',
								lineHeight: 1,
							}}
						>
							×
						</button>
					</div>
					<Sheet.Content>
						<div style={{ height: '70vh', width: '100%' }}>
							<iframe
								src="https://finvu.in/privacy"
								style={{
									width: '100%',
									height: '100%',
									border: 'none',
									borderRadius: '8px',
								}}
								title="Finvu Privacy Policy"
								loading="lazy"
								sandbox="allow-same-origin allow-scripts"
							/>
						</div>
					</Sheet.Content>
				</div>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default PrivacyPolicyModal;
